import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../auth/AuthContext";
import { AuthAside, AuthLegal, GoogleIcon } from "../components/AuthAside";
import "./Auth.css";

export default function Login() {
  const { user, login, googleLogin } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(params.get("error") === "google" ? "Google sign-in failed. Please try again." : "");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/dashboard", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <AuthAside />
      <main className="auth-main">
        <div className="auth-card" data-testid="login-card">
          <h1 className="auth-title">Sign in</h1>

          {error && <div className="auth-error" data-testid="login-error">{error}</div>}

          <form onSubmit={submit} className="auth-form">
            <div className="auth-field">
              <label htmlFor="login-email-input">Email</label>
              <input id="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required autoComplete="email" data-testid="login-email" />
            </div>
            <div className="auth-field">
              <label htmlFor="login-pw-input">Password</label>
              <input id="login-pw-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required autoComplete="current-password" data-testid="login-password" />
              <div className="auth-field-foot">
                <Link to="/forgot-password" className="auth-link" data-testid="forgot-link">Forgot password?</Link>
              </div>
            </div>
            <button className="auth-btn" type="submit" disabled={loading} data-testid="login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div className="auth-divider"><span>or</span></div>

          <button className="auth-google" onClick={googleLogin} data-testid="google-signin-btn">
            <GoogleIcon /> Continue with Google
          </button>

          <p className="auth-foot">
            New to Liturgical Intelligence™?{" "}
            <Link to="/register" data-testid="goto-register">Create an account</Link>
          </p>
        </div>

        <AuthLegal />
      </main>
    </div>
  );
}
